module.exports = __webpack_public_path__ + "img/icon_btm_jr2.9cc9271a.png";